"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactGateway = require("react-gateway");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ModalHeader = _styledComponents.default.div`
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;

  &::after {
    content: '';
    display: table;
    clear: both;
  }
`;
const ModalTitle = _styledComponents.default.h4`
  margin: 0;
  line-height: 1.5;
`;
const ModalBody = _styledComponents.default.div`
  position: relative;
  padding: 15px;
`;
const ModalFooter = _styledComponents.default.div`
  padding: 15px;
  text-align: right;
  border-top: 1px solid #e5e5e5;

  &::after {
    content: '';
    display: table;
    clear: both;
  }
`;
var _ref = /*#__PURE__*/_react.default.createElement("span", {
  "aria-hidden": "true"
}, "\xD7");
function BaseCloseButton(props) {
  return /*#__PURE__*/_react.default.createElement("button", _extends({}, props, {
    type: "button",
    "aria-label": "close",
    style: {
      outline: 'none'
    },
    onClick: props.onClick
  }), _ref);
}
const ModalCloseButton = (0, _styledComponents.default)(BaseCloseButton)`
  margin-top: -2px;

  float: right;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;

  &:focus,
  &:hover {
    color: #000;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.5;
  }

  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
`;
const ModalBackdrop = _styledComponents.default.div`
  z-index: 1000;
  position: fixed;
  overflow-y: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  -webkit-overflow-scrolling: touch;
`;
const ModalContent = _styledComponents.default.div`
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
`;
let previousBodyOverflow;
let numberOfModalsOpen = 0;
class ModalDialog extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onClickOuter", e => {
      e.stopPropagation();
    });
  }
  componentDidMount() {
    if (numberOfModalsOpen++ === 0) {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  }
  componentWillUnmount() {
    if (--numberOfModalsOpen === 0) {
      document.body.style.overflow = previousBodyOverflow;
    }
  }
  render() {
    // do not pass buttons, onClose etc to div
    // and do not pass title to buttons
    const {
      size,
      buttons,
      onClose,
      title,
      ...props
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_reactGateway.Gateway, {
      into: "top-level"
    }, /*#__PURE__*/_react.default.createElement(ModalBackdrop, {
      onClick: this.props.onClose
    }, /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
      tabIndex: "-1",
      onClick: this._onClickOuter
    }), /*#__PURE__*/_react.default.createElement(ModalContent, null, !title ? null : /*#__PURE__*/_react.default.createElement(ModalHeader, null, /*#__PURE__*/_react.default.createElement(ModalCloseButton, {
      onClick: this.props.onClose
    }), /*#__PURE__*/_react.default.createElement(ModalTitle, null, title)), /*#__PURE__*/_react.default.createElement(ModalBody, null, this.props.children), !this.props.buttons ? null : /*#__PURE__*/_react.default.createElement(ModalFooter, null, this.props.buttons)))));
  }
}
_defineProperty(ModalDialog, "defaultProps", {
  size: 'sm'
});
var _default = exports.default = (0, _styledComponents.default)(ModalDialog)`
  position: relative;
  width: auto;
  margin: 10px;
  margin-top: 100px;
  @media (min-width: 544px) {
    margin: 30px auto;
    margin-top: 100px;
    max-width: ${props => props.size === 'sm' ? '300px' : '600px'};
  }
  @media (min-width: 992px) {
    ${props => props.size === 'lg' ? 'max-width: 900px;' : ''};
  }
`;